<template>
  <div style="display: flex; align-items: center; gap: 0.25rem">
    <button class="comment__action__button" @click="showModal()">
      <Icon size="1.5em" name="material-symbols:report" />
      {{ $t('spotdetail.report_comment_button_text') }}
    </button>
    <Modal id="report_comment_modal">
      <div class="flex flex-col gap-2">
        <h3>{{ $t('spotdetail.report_comment_title') }}</h3>
        <i18n-t keypath="spotdetail.report_comment_text" scope="global" tag="p">
          <template v-slot:guidelines>
            <NuxtLink
              to="/guidelines"
              class="text-theme-primary underline"
              target="_blank"
              >{{ $t('spotdetail.report_spot_guidelines') }}
            </NuxtLink>
          </template>
        </i18n-t>
        <ButtonSubmit
          :loading="loading"
          :error="error"
          @click="reportComment()"
          :title="$t('spotdetail.report_comment_button_text')"
        />
      </div>
    </Modal>
  </div>
</template>
<script setup lang="ts">
const { $api } = useNuxtApp();

const loading = ref<boolean>(false);
const error = ref<boolean>(false);
const props = defineProps<{ spot: SpotDetail; comment: Comment }>();

function closeModal() {
  (document.getElementById('report_comment_modal') as HTMLFormElement).close();
}

function showModal() {
  (
    document.getElementById('report_comment_modal') as HTMLFormElement
  ).showModal();
}

function reportComment() {
  loading.value = true;
  error.value = false;
  $api<boolean>(
    'spots/' + props.spot.id + '/comments/' + props.comment.id + '/report'
  )
    .then(() => {
      loading.value = false;
      setTimeout(() => {
        closeModal();
      }, 500);
    })
    .catch((error) => {
      error.value = true;
    });
}
</script>
